import { useSelector } from 'react-redux';
import { selectUser } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import { selectAppOrgUsers } from '@/selectors/memoizedSelectors';

const useUserBelongsToApp: (appId: string) => boolean = (appId) => {
    const currentUser = useSelector((state: RootState) => selectUser(state));
    const appUsers = useSelector((state: RootState) => selectAppOrgUsers(state, appId));

    return appUsers.map((user) => user.id).includes(currentUser.id);
};

export default useUserBelongsToApp;
